import React from "react";
import { useDispatch } from "react-redux";
import BasePrompt from "components/base/prompt/BasePrompt";
import {
  FilterTypeEnum,
} from 'components/base/BaseFilter';
import { ImportResource } from 'models/DownloadImportModel';
import { PermissionCodes } from 'config/PermissionCodes';


const ExportEGLInvoiceModal = ({
  show = false,
  closeAction = () => { },
}) => {
  const [purchasedDateRange, setPurchasedDateRange] = React.useState()
  console.log("purchasedDateRange:", purchasedDateRange)
  const dispatch = useDispatch()
  const createDownloadTask = () => {
    const ranges = purchasedDateRange?.split(',')
    dispatch({
      type: "downloadAndImport/createDownloadTask", payload: {
        from: ImportResource.eglInvoiceReport,
        related: {
          purchasedDateGte: ranges?.[0],
          purchasedDateLte: ranges?.[1],
        },
      }
    })
  }
  return (
    <BasePrompt
      customClass={'export-report-modal'}
      show={show}
      title={"Export EGL Invoice Report"}
      description={'Select the transaction purchased date range'}
      closeAction={() => {
        setPurchasedDateRange(null)
        closeAction()
      }}
      otherBody={() => (
        <div className="d-flex">
          <FilterTypeEnum.dateRange title={""} value={purchasedDateRange} setValue={(data) => setPurchasedDateRange(data)} />
        </div>)
      }
      rightButton={{
        text: 'Export',
        action: () => {
          createDownloadTask()
          setPurchasedDateRange(null)
          closeAction()
        },
        requires: PermissionCodes.addExportjob,
      }}
    />)
}

export default ExportEGLInvoiceModal;